import { Back2 } from "../../../components/Option/Back";
import SDGIcon from "../../../assets/ambition_icons/sgd-icon.svg";
import "../index.css";
import "./index.css";
import sdg1 from "../../../assets/shapes_svg/sdg/1.png";
import sdg2 from "../../../assets/shapes_svg/sdg/2.png";
import sdg3 from "../../../assets/shapes_svg/sdg/3.png";
import sdg4 from "../../../assets/shapes_svg/sdg/4.png";
import sdg5 from "../../../assets/shapes_svg/sdg/5.png";
import sdg6 from "../../../assets/shapes_svg/sdg/6.png";
import sdg7 from "../../../assets/shapes_svg/sdg/7.png";
import sdg8 from "../../../assets/shapes_svg/sdg/8.png";
import sdg9 from "../../../assets/shapes_svg/sdg/9.png";
import sdg10 from "../../../assets/shapes_svg/sdg/10.png";
import sdg11 from "../../../assets/shapes_svg/sdg/11.png";
import sdg12 from "../../../assets/shapes_svg/sdg/12.png";
import sdg13 from "../../../assets/shapes_svg/sdg/13.png";
import sdg14 from "../../../assets/shapes_svg/sdg/14.png";
import sdg15 from "../../../assets/shapes_svg/sdg/15.png";
import sdg16 from "../../../assets/shapes_svg/sdg/16.png";
import sdg17 from "../../../assets/shapes_svg/sdg/17.png";
import header from "../../../assets/shapes_svg/sdg/header.png";
import deleteicon from "../../../assets/shapes_svg/sdg/delete.svg";
import { useState } from "react";
import { createContext } from "react";
import { useContext } from "react";

import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import Step4 from "./Step4";
import Step7 from "./Step7";
import Step8 from "./Step8";
// import { getHighlight, updateHighlight } from "../../../apis/Ambition";
import { useEffect } from "react";
import {
  getHighlightList,
  updateHighlightList,
} from "../../../apis/AmbitionList";
import Step5 from "./Step5";
import Step6 from "./Step6";
import Step9 from "./Step9";
import { ContainerBody } from "../../../App";

const SDGminiicon = ({ src }) => {
  const { setRelevantGoals } = useContext(RelevantGoals);

  const handleClick = () => {
    setRelevantGoals((prevGoal) => {
      return prevGoal.filter((goal) => goal.src !== src);
    });
  };
  return (
    <div className="mt-3" style={{ position: "relative" }}>
      <img style={{ cursor: "pointer" }} src={src} alt="" />
      <img
        onClick={handleClick}
        style={{
          position: "absolute",
          right: "-10%",
          bottom: "-10%",
          width: "20%",
          cursor: "pointer",
        }}
        src={deleteicon}
        alt="Add to relevant goals"
      />
    </div>
  );
};

const SDGicon = ({ sdg, src, link }) => {
  const { relevantGoals, setRelevantGoals } = useContext(RelevantGoals);
  const handleClick = () => {
    setRelevantGoals((prevGoal) => {
      if (prevGoal.length < 4) return [...prevGoal, sdg];
      else return prevGoal;
    });
  };

  return (
    <div className="me-3 mb-3" style={{ position: "relative" }}>
      <a href={link} target="_blank">
        <img style={{ cursor: "pointer" }} src={src} alt="" />
      </a>
      {Array.isArray(relevantGoals) &&
      (relevantGoals.filter((goal) => goal.src === sdg.src).length > 0 ||
        relevantGoals.length >= 4) ? null : (
        <img
          onClick={handleClick}
          style={{
            position: "absolute",
            right: "-15%",
            bottom: "-15%",
            transform: "rotate(45deg)",
            width: "30%",
            cursor: "pointer",
          }}
          src={deleteicon}
          alt="Add to relevant goals"
        />
      )}
    </div>
  );
};

export const RelevantGoals = createContext();
const SDGmain = () => {
  const SDGdef = `For a definition of the SDGs please visit our Glossary. Or seek out "the sdgs" course under the education tab for a more elaborate explanation.

In this ambition you can get guidance on creating a well thought out, datadriven and company relevant roadmap and timeline, for your company wide effort and long-term strategy work on the SDG agenda.

A roadmap is a strategic plan for translating your company vision into actionable goals and concrete activities`;

  const goalwashing = `You have no data from measurements over time, to back up your claims to be working with the goals
You are spending more money on talking about your effort, than on the actual effort.

You have placed already existing initiatives into as many goals as possible. You are cherry-picking the easiest ones to achieve instead of the ones with most impact. This is our recommendation on how to get started with the SDGs on a strategic level. There are many ways to get started with the SDGs, this is just one of them.

We are aligning the work here with the methodology suggested by the WBCSD (World Business Council for Sustainable Development), combined with years of experience of consulting in corporations`;
  const [relevantGoals, setRelevantGoals] = useState([]);
  const handleGetRelevantGoals = () => {
    getHighlightList({
      key: "relevant_goals",
      setValue: setRelevantGoals,
    });
  };
  const handleUpdateRelevantGoals = () => {
    updateHighlightList({
      key: "relevant_goals",
      value: relevantGoals,
    });
  };

  useEffect(() => {
    handleGetRelevantGoals();
  }, []);

  useEffect(() => {
    if (relevantGoals.length > 0) handleUpdateRelevantGoals();
  }, [relevantGoals]);

  const sdgs = [
    {
      title: "End poverty in all its forms everywhere",
      key: "SDG_1",
      src: sdg1,
      link: "https://www.un.org/sustainabledevelopment/poverty/",
    },
    {
      title: "Zero Hunger",
      key: "SDG_2",
      src: sdg2,
      link: "https://www.un.org/sustainabledevelopment/hunger/",
    },
    {
      title: "Ensure healthy lives and promote well-being for all at all ages",
      key: "SDG_3",
      src: sdg3,
      link: "https://www.un.org/sustainabledevelopment/health/",
    },
    {
      title: "Quality Education",
      key: "SDG_4",
      src: sdg4,
      link: "https://www.un.org/sustainabledevelopment/education/",
    },
    {
      title: "Achieve gender equality and empower all women and girls",
      key: "SDG_5",
      src: sdg5,
      link: "https://www.un.org/sustainabledevelopment/gender-equality/",
    },
    {
      title: "Ensure access to water and sanitation for all",
      key: "SDG_6",
      src: sdg6,
      link: "https://www.un.org/sustainabledevelopment/water-and-sanitation/",
    },
    {
      title:
        "Ensure access to affordable, reliable, sustainable and modern energy",
      key: "SDG_7",
      src: sdg7,
      link: "https://www.un.org/sustainabledevelopment/energy/",
    },
    {
      title:
        "Promote inclusive and sustainable economic growth, employment and decent work for all",
      key: "SDG_8",
      src: sdg8,
      link: "https://www.un.org/sustainabledevelopment/economic-growth/",
    },
    {
      title:
        "Build resilient infrastructure, promote sustainable industrialization and foster innovation",
      key: "SDG_9",
      src: sdg9,
      link: "https://www.un.org/sustainabledevelopment/infrastructure-industrialization/",
    },
    {
      title: "Reduce inequality within and among countries",
      key: "SDG_10",
      src: sdg10,
      link: "https://www.un.org/sustainabledevelopment/inequality/",
    },
    {
      title: "Make cities inclusive, safe, resilient and sustainable",
      key: "SDG_11",
      src: sdg11,
      link: "https://www.un.org/sustainabledevelopment/cities/",
    },
    {
      title: "Ensure sustainable consumption and production patterns",
      key: "SDG_12",
      src: sdg12,
      link: "https://www.un.org/sustainabledevelopment/sustainable-consumption-production/",
    },
    {
      title: "Take urgent action to combat climate change and its impacts",
      key: "SDG_13",
      src: sdg13,
      link: "https://www.un.org/sustainabledevelopment/climate-change/",
    },
    {
      title:
        "Conserve and sustainably use the oceans, seas and marine resources",
      key: "SDG_14",
      src: sdg14,
      link: "https://www.un.org/sustainabledevelopment/oceans/",
    },
    {
      title:
        "Sustainably manage forests, combat desertification, halt and reverse land degradation, halt biodiversity loss",
      key: "SDG_15",
      src: sdg15,
      link: "https://www.un.org/sustainabledevelopment/biodiversity/",
    },
    {
      title: "Promote just, peaceful and inclusive societies",
      key: "SDG_16",
      src: sdg16,
      link: "https://www.un.org/sustainabledevelopment/peace-justice/",
    },
    {
      title: "Revitalize the global partnership for sustainable development",
      key: "SDG_17",
      src: sdg17,
      link: "https://www.un.org/sustainabledevelopment/globalpartnerships/",
    },
  ];

  return (
    <RelevantGoals.Provider value={{ relevantGoals, setRelevantGoals }}>
      <ContainerBody className="ambition__body">
        <div
          className="companydetail__wrapper2"
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "20px",
            height: "0",
          }}
        >
          <Back2
            header={"Back to Company Page"}
            style={{ marginRight: "auto", position: "relative", left: "-7%" }}
            to={"/ambition"}
          />
        </div>
        <div className="ambition__esg__items mt-3">
          <div
            className="ambition__role__role"
            style={{ justifyContent: "space-around", flexWrap: "wrap" }}
          >
            <div className="d-flex align-items-center justify-content-center flex-column align-self-start">
              <div
                className="ambition__body__item"
                style={{ padding: "20px", justifyContent: "space-between" }}
              >
                <h4>SDG</h4>
                <h5>Sustainable Development Goals</h5>

                <img
                  src={SDGIcon}
                  alt="SDG Icon"
                  style={{ marginTop: "10px" }}
                />
              </div>
              <div className="ambition__bubblesmall d-flex p-3 align-items-center justify-content-center mt-3 flex-column">
                <h4 style={{ textAlign: "center" }}>Relevant Goals</h4>
                {Array.isArray(relevantGoals) &&
                  relevantGoals.map((goal) => {
                    return <SDGminiicon key={goal.src} src={goal.src} />;
                  })}
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-center flex-column w-70">
              <img src={header} alt="" />
              <div className="d-flex flex-wrap p-3 align-items-center">
                {sdgs.map((sdg) => {
                  return <SDGicon sdg={sdg} src={sdg.src} link={sdg.link} />;
                })}
              </div>
              <div className="roleambition__bubble w-100 mt-3">
                <h4>What are Sustainable Development Goals ?</h4>
                <h5>{SDGdef}</h5>
              </div>
              <div className="roleambition__bubble w-100 mt-3">
                <h4>
                  How to know if you are <b>goal-washing</b>
                </h4>
                <h5>{goalwashing}</h5>
              </div>
            </div>
          </div>
          <Step1 />
          <Step2 />
          <Step3 />
          <Step4 />
          <Step5 />
          <Step6 />
          <Step7 />
          <Step8 />
          <Step9 />
        </div>
      </ContainerBody>
    </RelevantGoals.Provider>
  );
};

export default SDGmain;
